import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var CreateFlashcards = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    d: "M16.093 22.367a.91.91 0 0 1 .91-.911h3.948v-3.947a.91.91 0 0 1 1.821 0v3.947h3.948a.911.911 0 0 1 0 1.822h-3.948v3.947a.91.91 0 0 1-1.821 0v-3.948h-3.948a.91.91 0 0 1-.91-.91Z"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.598 38.46h10.804l7.904 1.264a4.554 4.554 0 0 0 5.217-3.777l3.42-21.361a4.555 4.555 0 0 0-3.778-5.217l-6.653-1.065a4.557 4.557 0 0 0-4.363-3.244H14.574a4.556 4.556 0 0 0-4.377 3.29L3.835 9.37a4.554 4.554 0 0 0-3.777 5.217l3.42 21.36a4.554 4.554 0 0 0 5.216 3.778l7.904-1.265ZM14.574 6.88a2.733 2.733 0 0 0-2.732 2.733v24.29a2.733 2.733 0 0 0 2.732 2.733H29.15a2.733 2.733 0 0 0 2.732-2.732V9.888l-.026-.005v-.65a2.733 2.733 0 0 0-2.706-2.352H14.574Zm19.13 27.024V10.179l6.173.989a2.733 2.733 0 0 1 2.266 3.13l-3.42 21.361a2.733 2.733 0 0 1-3.13 2.266l-3.486-.558a4.544 4.544 0 0 0 1.596-3.462Zm-22.044 3.5-3.254.52a2.733 2.733 0 0 1-3.13-2.266l-3.42-21.361a2.733 2.733 0 0 1 2.267-3.13l5.897-.944v23.68c0 1.407.638 2.665 1.64 3.5Z"
  }));
});
CreateFlashcards.displayName = 'CreateFlashcards';
CreateFlashcards.defaultProps = {
  'aria-label': 'CreateFlashcards'
};
export default CreateFlashcards;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Web/CreateFlashcards.js
// module id = 3762
// module chunks = 11